export const MenuIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 21'>
    <g transform='translate(-388 -282)'>
      <circle cx='2.5' cy='2.5' r='2.5' transform='translate(388 282)' fill='#fff' />
      <circle cx='2.5' cy='2.5' r='2.5' transform='translate(388 290)' fill='#fff' />
      <circle cx='2.5' cy='2.5' r='2.5' transform='translate(388 298)' fill='#fff' />
    </g>
  </svg>
);
